/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RenewTemporaryGrantForm,
  RenewTemporaryGrantForm$Outbound,
  RenewTemporaryGrantForm$outboundSchema,
} from "../components/renewtemporarygrantform.js";

export type RenewTemporaryGrantSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RenewTemporaryGrantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  renewTemporaryGrantForm: RenewTemporaryGrantForm;
};

/** @internal */
export type RenewTemporaryGrantSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RenewTemporaryGrantSecurity$outboundSchema: z.ZodMiniType<
  RenewTemporaryGrantSecurity$Outbound,
  RenewTemporaryGrantSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function renewTemporaryGrantSecurityToJSON(
  renewTemporaryGrantSecurity: RenewTemporaryGrantSecurity,
): string {
  return JSON.stringify(
    RenewTemporaryGrantSecurity$outboundSchema.parse(
      renewTemporaryGrantSecurity,
    ),
  );
}

/** @internal */
export type RenewTemporaryGrantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RenewTemporaryGrantForm: RenewTemporaryGrantForm$Outbound;
};

/** @internal */
export const RenewTemporaryGrantRequest$outboundSchema: z.ZodMiniType<
  RenewTemporaryGrantRequest$Outbound,
  RenewTemporaryGrantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    renewTemporaryGrantForm: RenewTemporaryGrantForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      renewTemporaryGrantForm: "RenewTemporaryGrantForm",
    });
  }),
);

export function renewTemporaryGrantRequestToJSON(
  renewTemporaryGrantRequest: RenewTemporaryGrantRequest,
): string {
  return JSON.stringify(
    RenewTemporaryGrantRequest$outboundSchema.parse(renewTemporaryGrantRequest),
  );
}
